<ng-container class="report-custom-container">
  <app-report-select
    [title]="'Reporte de facturación'"
    [hidePreview]="true"
    [hidePrint]="true"
    [hideText]="false"
    [disabled]="form.invalid || !dataRequested || dataSource.data.length === 0"
    [canSaveDraft]="true"
    [draftDataId]="draftDataId"
    [draftData]="draftData"
    (pdfClicked)="handleGeneratePDF()"
    (textClicked)="handleGenerateReport()"
    (excelClicked)="handleGenerateExcel()"
    (onRestoreData)="handleRestoreData($event)"
  >
    <div slot="content" class="tw-flex tw-flex-col tw-gap-3 tw-px-[10px]">
      <form [formGroup]="form" class="tw-flex tw-flex-col tw-gap-3">
        <div class="tw-flex tw-flex-row tw-gap-3">
          <section>
            <div class="tw-pl-2 tw-mb-2 tw-text-primary tw-font-bold tw-text-[0.7rem] tw-uppercase">Centro</div>
            <app-form-field
              class="
                tw-w-40
                [&_mat-form-field]:!tw-mb-0 [&_mat-form-field]:!tw-h-fit
                [&_mat-form-field_.mat-mdc-input-element]:tw-translate-y-[3px]
              "
              [type]="'select'"
              label="Selecciona el centro"
              [fieldControl]="form.controls['selectedInstitution'] | asFormControl"
              [options]="selectOptionsInsitutions"
              [multipleSelect]="false">
            </app-form-field>
          </section>

          <section>
            <div class="tw-pl-2 tw-mb-2 tw-text-primary tw-font-bold tw-text-[0.7rem] tw-uppercase">Fecha</div>

            <div class="tw-flex tw-flex-row tw-gap-3">
              <app-form-field
                class="
                  tw-w-40
                  [&_mat-form-field]:!tw-mb-0 [&_mat-form-field]:!tw-h-fit
                  [&_mat-form-field_.mat-mdc-input-element]:tw-translate-y-[3px]
                "
                [type]="'date'"
                label="Desde"
                [fieldControl]="form.controls['fromDate'] | asFormControl"
                [maxDate]="maxDateFrom"
                >
              </app-form-field>

              <app-form-field
                class="
                  tw-w-40
                  [&_mat-form-field]:!tw-mb-0 [&_mat-form-field]:!tw-h-fit
                  [&_mat-form-field_.mat-mdc-input-element]:tw-translate-y-[3px]
                "
                [type]="'date'"
                label="Hasta"
                [fieldControl]="form.controls['toDate'] | asFormControl"
                [minDate]="minDateTo"
                [maxDate]="maxDate"
                >
              </app-form-field>
            </div>
          </section>

          <section class="tw-flex tw-items-end tw-gap-3">
            <button
              mat-raised-button color="primary"
              class="!tw-h-[38px]"
              [disabled]="form.invalid"
              (click)="requestData()"
            >
              <mat-icon>search</mat-icon>
              Obtener datos
            </button>

            <button
              *ngIf="hiddenData.length > 0"
              mat-raised-button
              color="accent"
              class="!tw-h-[38px]"
              (click)="openAddHiddenDataDialog()"
            >
              <mat-icon>add</mat-icon>
              Añadir otros
            </button>
          </section>
        </div>

        <section class="tw-w-full tw-flex tw-flex-row tw-gap-3" *ngIf="dataRequested && dataSource.data.length > 0">
          <app-form-field
            class="tw-w-56 [&_mat-form-field]:!tw-mb-0 [&_mat-form-field]:!tw-h-fit"
            [type]="'text'"
            [fieldControl]="form.controls['filter'] | asFormControl"
            [label]="'Filtrar'"
          >
          </app-form-field>

          <app-form-field
            class="tw-w-56 [&_mat-form-field]:!tw-mb-0 [&_mat-form-field]:!tw-h-fit"
            [type]="'radio'"
            [options]="[
              { label: 'Numerico', value: 1 },
              { label: 'Descriptivo', value: 2 }
            ]"
            [fieldControl]="form.controls['displayMode'] | asFormControl"
            [label]="''"
          >
          </app-form-field>
        </section>
      </form>

      <div *ngIf="dataSource.data.length" class="tw-text-primary tw-text-sm">
        <span class="tw-font-bold">{{dataSource.data.length}}</span> registros
      </div>

      <div #list class="tw-w-full tw-h-[calc(100%-0.5rem)] tw-overflow-y-auto tw-rounded-lg">
        <table 
          mat-table 
          [dataSource]="dataSource" 
          matSort
          class="!tw-bg-white tw-rounded-lg"
          *ngIf="dataRequested"
        >
          <!-- CIPNA -->
          <ng-container matColumnDef="FIPACIENTE">
            <th 
              mat-header-cell 
              mat-sort-header 
              *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none !tw-rounded-l-lg"
              [ngClass]="{'!tw-w-64': form.controls['displayMode'].value === 2}"
            > 
              <span *ngIf="form.controls['displayMode'].value === 1">CIPNA</span> 
              <span *ngIf="form.controls['displayMode'].value === 2">Paciente</span> 
            </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                *ngIf="form.controls['displayMode'].value === 1"
                type="text" 
                [formControl]="getFieldControl(element, 'FIPACIENTE')"
                (blur)="onCipnaChange(element, i)"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary"
              />
              <span *ngIf="form.controls['displayMode'].value === 2"> {{ element.NombrePaciente }} </span>
            </td>
          </ng-container>
    
          <!-- CIE -->
          <ng-container matColumnDef="FICIAP">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none"> CIE </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                type="text" 
                [formControl]="getFieldControl(element, 'FICIAP')"
                (blur)="onCieChange(element, i)"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary tw-font-bold"
              />
            </td>
          </ng-container>
        
          <!-- Código nacional -->
          <ng-container matColumnDef="FIMEDICA">
            <th 
              mat-header-cell 
              mat-sort-header 
              *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none"
              [ngClass]="{'!tw-w-64': form.controls['displayMode'].value === 2}"
            >
              <span *ngIf="form.controls['displayMode'].value === 1">CN</span>
              <span *ngIf="form.controls['displayMode'].value === 2">Medicamento</span> 
            </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                *ngIf="form.controls['displayMode'].value === 1"
                type="number" 
                [formControl]="getFieldControl(element, 'FIMEDICA')"  
                (blur)="onCodigoNacionalChange(element, i)"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary !tw-text-primary tw-font-bold tw-uppercase"
              />
              <span *ngIf="form.controls['displayMode'].value === 2"> {{ element.NombreMedicamento }} </span>
            </td>
          </ng-container>
    
          <!-- Precio -->
          <ng-container matColumnDef="FIMPORTEC">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-p-2 !tw-text-white !tw-bg-primary !tw-border-none"> Precio </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                type="number" 
                step="0.01"
                [formControl]="getFieldControl(element, 'FIMPORTEC')" 
                (blur)="onPrecioChange(element, i)"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary !tw-text-primary tw-font-bold tw-uppercase"
              />
            </td>
          </ng-container>

          <!-- Precio con IVA -->
          <ng-container matColumnDef="FIMPORTECIVA">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-p-2 !tw-text-white !tw-bg-primary !tw-border-none"> Precio IVA </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                type="number" 
                step="0.01"
                readonly
                [formControl]="getFieldControl(element, 'FIMPORTECIVA')" 
                (blur)="onPrecioChange(element, i)"
                class="tw-pointer-events-none tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary !tw-text-primary tw-font-bold tw-uppercase"
              />
            </td>
          </ng-container>
    
          <!-- Unidades envase -->
          <ng-container matColumnDef="FIUNIENV">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-p-2 !tw-text-white !tw-bg-primary !tw-border-none"> U/envase </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                type="number" 
                [formControl]="getFieldControl(element, 'FIUNIENV')"  
                (blur)="onUnidadesEnvaseChange(element, i)"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary !tw-text-primary tw-font-bold tw-uppercase"
              />
            </td>
          </ng-container>
    
          <!-- Unidades dia consumidas -->
          <ng-container matColumnDef="FIUNIDIA">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-p-2 !tw-text-white !tw-bg-primary !tw-border-none"> U/dia consumidas </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                type="number" 
                [formControl]="getFieldControl(element, 'FIUNIDIA')"    
                (blur)="onUnidadesDiaConsumidasChange(element, i)"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary !tw-text-primary tw-font-bold tw-uppercase"
              />
            </td>
          </ng-container>
    
          <!-- Dias tratamiento -->
          <ng-container matColumnDef="FIDIAS">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-p-2 !tw-text-white !tw-bg-primary !tw-border-none"> Dias tratamiento </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                type="number" 
                [formControl]="getFieldControl(element, 'FIDIAS')"    
                (blur)="onDiasTratamientoChange(element, i)"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary !tw-text-primary tw-font-bold tw-uppercase"
              />
            </td>
          </ng-container>

          <!-- IVA -->
          <ng-container matColumnDef="IVA">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-p-2 !tw-text-white !tw-bg-primary !tw-border-none"> IVA </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input
                type="number"
                step="0.01"
                [formControl]="getFieldControl(element, 'IVA')"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary !tw-text-primary tw-font-bold tw-uppercase"
              />
            </td>
          </ng-container>

          <!-- Importe facturado -->
          <ng-container matColumnDef="FIMPORTEF">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-p-2 !tw-text-white !tw-bg-primary !tw-border-none"> Importe facturado </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                type="number" 
                step="0.01"
                [formControl]="getFieldControl(element, 'FIMPORTEF')" 
                (blur)="onImporteFacturadoChange(element, i)"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary !tw-text-primary tw-font-bold tw-uppercase"
              />
            </td>
          </ng-container>
    
          <!-- Tipo compra -->
          <ng-container matColumnDef="TIPOCOMPRA">
            <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none !tw-w-44 !tw-shrink-0"> Tipo compra </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <app-form-field
                *ngIf="tableFormArray.at(i) as rowForm"
                [type]="'radio'"
                [options]="[
                  { label: 'Lab', value: 1 },
                  { label: 'Distr', value: 2 }
                ]"
                [fieldControl]="getFieldControl(element, 'TIPOCOMPRA')"
                [label]="''"
              >
              </app-form-field>
            </td>
          </ng-container>
    
          <!-- Factura -->
          <!-- <ng-container matColumnDef="NFACTURA">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none"> Factura </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <input 
                type="text" 
                [(ngModel)]="element.NFACTURA"
                (blur)="onFacturaChange(element, i)"
                class="tw-w-full tw-px-2 tw-py-1 tw-text-sm tw-border tw-border-gray-300 tw-rounded focus:tw-outline-none focus:tw-border-primary focus:tw-ring-1 focus:tw-ring-primary !tw-text-primary tw-font-bold tw-uppercase"
              />
            </td>
          </ng-container> -->

          <!--  -->
          <ng-container matColumnDef="ACCIONES">
            <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none !tw-rounded-r-lg"> Acciones </th>
            <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10 tw-text-sm !tw-p-1">
              <button mat-icon-button (click)="onDeleteRow(element, i)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr 
            mat-header-row 
            *matHeaderRowDef="displayedColumns; sticky: true;" 
            class="!tw-h-10 tw-text-xs !tw-bg-transparent"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns;"
            class="hover:!tw-bg-primary/5"
          ></tr>
        <!-- Fila cuando no hay resultados -->
        <tr 
          *matNoDataRow 
          class="hover:!tw-bg-transparent"
        >
          <td 
            [attr.colspan]="displayedColumns.length" 
            class="!tw-text-center !tw-py-8 !tw-text-gray-500 !tw-border-none"
          >
            <div class="tw-flex tw-flex-col tw-items-center tw-gap-2">
              <mat-icon class="!tw-w-[48px] !tw-h-[48px] !tw-text-[48px] tw-flex tw-items-center tw-justify-center tw-text-gray-400">search_off</mat-icon>
              <span class="tw-text-base tw-font-medium">No se encontraron resultados</span>
              <span class="tw-text-sm tw-text-gray-400">Intenta ajustar los filtros de búsqueda</span>
            </div>
          </td>
        </tr>
        </table>
      </div>
    </div>
  </app-report-select>
</ng-container>